<template>
  <div class="radio-question-wrapper">
    <base-question :is-detail="isDetail" :index="index" :question-data="questionData">
      <radio-type :is-detail="isDetail" :question-data="questionData" @onChange="onChange" />
      <div v-for="(child, key) in childAnswerList" :key="key" class="relation-wrapper">
        <div v-if="isFilled(child)">
          <div v-if="child.optionType === 3" class="upload-wrapper">
            <upload-type
              :is-detail="isDetail"
              :value="child"
              :risk-pic="riskPic"
              @input="(val) => changeData(val, child)"
              @uploading="(val) => uploading(val, child)" />
          </div>
          <div v-else class="fill-wrapper">
            <fill-type
              :is-detail="isDetail"
              :value="child" />
          </div>
        </div>
      </div>
      <div v-if="!isLast && questionData.answerType !== 1 && !isDetail && childAnswerList.length === 0" class="skip-btn" @click="skip">跳过此题</div>
    </base-question>
  </div>
  
</template>

<script>
import BaseQuestion from './base.vue'
import RadioType from '../types/radioType.vue'
import FillType from '../types/fillType.vue'
import UploadType from '../types/uploadType.vue'

export default {
  name: 'RadioQuestion',
  props: {
    questionData: {
      type: Object,
      default: ()=>{}
    },
    value: {
      type: Number,
      default: 0
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    riskPic: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BaseQuestion,
    RadioType,
    FillType,
    UploadType
  },
  data() {
    return {
    };
  },
  computed: {
    chosenAnswer() {
      return this.questionData.memberAnswerList.filter(item => item.memberOptionSelected === 1)?.[0];
    },
    childAnswerList() {
      return this.chosenAnswer?.childAnswerList || [];
    }
  },
  methods: {
    isFilled(child) {
      if (this.isDetail) {
        return child.memberAnswerPicList?.length > 0 || child.memberOptionContent;
      } else {
        return true;
      }
    },
    changeData(val, child) {
      this.$set(child, 'memberAnswerPicList', val?.memberAnswerPicList || []);
    },
    uploading(val) {
      this.$emit('uploading', val);
    },
    onChange() {
      if (!this.childAnswerList?.length && !this.isLast) {
        this.$emit('input', this.value + 1);
      }
      this.$set(this.questionData, 'questionJoin', 1);
    },
    skip() {
      this.$sensors.track('survey_skip_click', {
        num: this.value + 1,
        memberQuestionnaireId: this.$route.query.memberQuestionnaireId
      });
      const memberAnswerList = this.questionData.memberAnswerList?.map(item => {
        return {
          ...item, 
          memberOptionSelected: 0
        }
      });
      this.$set(this.questionData, 'value', null);
      this.$set(this.questionData, 'questionJoin', 0);
      this.$set(this.questionData, 'memberAnswerList', memberAnswerList);
      this.$emit('input', this.value + 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-question-wrapper {
  margin-top: 12px;
  .skip-btn {
    margin-top: 56px;
    font-weight: 400;
    font-size: 24px;
    color: #979797;
    text-align: center;
  }
}
.relation-wrapper {
  .upload-wrapper, .fill-wrapper {
    margin-top: 32px;
  }
}
</style>
